@let p = person();

<lvr-nav-carousel
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
></lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditSponsorPersons()"
	[showDeleteButton]="canDeleteSponsorPersons()"
	[deleteTranslationKey]="'sponsor.persons.deactivate.deactivate'"
	[disableDeleteButton]="!!p!.isDeactivated"
	[disableDeleteTranslationKey]="disableDeleteTranslationKey"
	[disableEditButton]="!!p!.isDeactivated"
	[disableEditTranslationKey]="disableDeleteTranslationKey"
	(editClicked)="openEdit()"
	(deleteClicked)="openDialog()"
>
	{{ 'sponsor.persons.details.title' | transloco: { name: personName() } }}
</lvr-heading>

<section class="grid">
	<table>
		<tr>
			<th scope="col">{{ 'sponsor.persons.details.name' | transloco }}</th>
			<th scope="col">{{ 'sponsor.persons.details.first_name' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ p?.name }}</td>
			<td>{{ p?.firstName }}</td>
		</tr>

		<tr>
			<th scope="col">{{ 'sponsor.persons.details.person_title' | transloco }}</th>
			<th scope="col">{{ 'sponsor.persons.details.function_department' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ p?.title }}</td>
			<td>{{ p?.role }}</td>
		</tr>

		<tr>
			<th scope="col">{{ 'sponsor.persons.details.gender' | transloco }}</th>
			<th scope="col">{{ 'sponsor.persons.details.address' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ p?.gender?.salutation }}</td>
			<td>
				{{ p?.address?.streetAndHouseNumber }}<br />
				{{ p?.address?.postalCodeAndCity }}
			</td>
		</tr>

		<tr>
			<th scope="col" colspan="2">{{ 'sponsor.persons.details.privacy_clarification' | transloco }}</th>
		</tr>
		<tr>
			<td colspan="2">
				{{
					p?.hasBeenClarified
						? ('institution.persons.details.true' | transloco)
						: ('institution.persons.details.false' | transloco)
				}}
			</td>
		</tr>

		<tr>
			<th scope="col">{{ 'sponsor.persons.details.preferred_communication' | transloco }}</th>
			<th scope="col">{{ 'sponsor.persons.details.other_communication' | transloco }}</th>
		</tr>
		<tr>
			<td>
				<ul>
					@for (cp of preferredCommunicationPoints(); track cp.id) {
						@if (cp.categoryContactPointId === contactTypes.phone) {
							<li>
								<a [href]="'tel:' + cp.contactValue">{{ cp.contactValue }}</a>
								<p>{{ cp.remark }}</p>
							</li>
						} @else if (cp.categoryContactPointId === contactTypes.email) {
							<li>
								<a [href]="'mailto:' + cp.contactValue">{{ cp.contactValue }}</a>
								<p>{{ cp.remark }}</p>
							</li>
						} @else {
							<li>
								<p>{{ cp.contactValue }}</p>
								<p>{{ cp.remark }}</p>
							</li>
						}
					}
				</ul>
			</td>
			<td>
				<ul>
					@for (cp of otherCommunicationPoints(); track cp.id) {
						@if (cp.categoryContactPointId === contactTypes.phone) {
							<li>
								<a [href]="'tel:' + cp.contactValue">{{ cp.contactValue }}</a>
								<p>{{ cp.remark }}</p>
							</li>
						} @else if (cp.categoryContactPointId === contactTypes.email) {
							<li>
								<a [href]="'mailto:' + cp.contactValue">{{ cp.contactValue }}</a>
								<p>{{ cp.remark }}</p>
							</li>
						} @else {
							<li>
								<p>{{ cp.contactValue }}</p>
								<p>{{ cp.remark }}</p>
							</li>
						}
					}
				</ul>
			</td>
		</tr>

		<tr>
			<th scope="col" colspan="2">{{ 'sponsor.persons.details.remark' | transloco }}</th>
		</tr>
		<tr>
			<td colspan="2">{{ p?.remark }}</td>
		</tr>
	</table>
</section>
